
import React from "react";
import img1 from "./imgs/R6.jpg";
import img2 from "./imgs/19.Ultra R6-双页-中文.jpg";
import {DEFAULT_LOCALE, LOCALES_HELPER} from "../../../../locales/config";
import img1en from "./imgs/R6.jpg";
import img2en from "./imgs/19-Ultra R6.jpg";

export function dxq() {

    const lang = LOCALES_HELPER.getLan();

    return (
        <>
            {lang === DEFAULT_LOCALE
                ? <>
                    <img className="product-img" src={img1}/>
                    <img className="product-img" src={img2}/>
                </>
                : <>
                    <img className="product-img" src={img1en}/>
                    <img className="product-img" src={img2en}/>
                </>
            }
        </>
    )
}